/**
 * Номер версии, который видит человек: в меню и в настройках, в разделе
 * «Поддержка». По нему поддержка понимает, что стоит у человека.
 *
 * Пока ведётся руками и поднимается отдельным коммитом, как и раньше.
 * Задел на будущее: номер берётся только отсюда, поэтому перейти на version
 * из package.json — правка одной строки. В vue.config.js через chainWebpack
 * подкладывается DefinePlugin с
 *   'process.env.APP_VERSION': JSON.stringify(require('./package.json').version)
 * а здесь остаётся
 *   export const APP_VERSION = process.env.APP_VERSION;
 * Не забыть до этого выставить в package.json настоящий номер: там 0.1.0.
 */
// eslint-disable-next-line import/prefer-default-export
export const APP_VERSION = '1.13.8';
